import {Serialisable} from "../serialisable";
import {BranchDto} from "./branch.dto";

export class DeviceDto extends Serialisable {
    id: number;
    branchId: number;

    name: string;

    bookmaticStatusId: string;
    bookmaticStatusName: string;
    lastCommunicationUtc: number;

    branch: BranchDto;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/device.dto.ts